import {
  Backdrop,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
  AMPLITUDE_API_KEY,
  AUTOMATIC_AMPLITUDE_ANALYTICS_CONSENT,
} from '../../../commonUtils/config';
import {
  getAnalyticsConsent,
  setAnalyticsConsent,
} from '../../../commonUtils/utilFunctions';
import {
  initializeAmplitude,
  removeAmplitudeCookies,
} from '../../../lib/analytics/amplitude';

interface AnalyticsConsentDialogProps {
  open: boolean;
  onAccept: () => void;
  onReject: () => void;
}
export const AnalyticsConsentDialog = (props: AnalyticsConsentDialogProps) => {
  const { open, onAccept, onReject } = props;
  return (
    <Dialog
      open={open}
      hideBackdrop={false}
      disableEscapeKeyDown
      slots={{
        backdrop: Backdrop,
      }}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(5px)',
            backgroundColor: 'rgba(0,0,0,0.35)',
          },
        },
      }}
      PaperProps={{
        sx: {
          position: 'fixed',
          bottom: 24,
          m: 2,
          // width: {
          //   xs: 'unset',
          //   sm: 500,
          // },
          width: '90%',
          maxWidth: 500,
          borderRadius: 3,
          bgcolor: '#fff',
          color: '#000',
          boxShadow: 8,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          pb: 1,
        }}
      >
        Optional analytics cookies
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="body2"
          sx={{
            color: '#555',
            lineHeight: 1.7,
          }}
        >
          With your permission, we use Amplitude analytics cookies and related
          account, device, session, and interaction data to understand how Geneo
          is used and improve the platform. Amplitude will only be enabled if
          you accept. Rejecting analytics will not affect your access to Geneo.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          pt: 2,
          gap: 1.5,
        }}
      >
        <Button
          fullWidth
          variant="outlined"
          onClick={onReject}
          sx={{
            borderColor: '#000',
            color: '#000',
            textTransform: 'none',
            borderRadius: 2,
            '&:hover': {
              borderColor: '#000',
              bgcolor: '#f5f5f5',
            },
          }}
        >
          Reject analytics
        </Button>

        <Button
          fullWidth
          variant="contained"
          onClick={onAccept}
          sx={{
            bgcolor: '#000',
            color: '#fff',
            textTransform: 'none',
            borderRadius: 2,
            '&:hover': {
              bgcolor: '#222',
            },
          }}
        >
          Accept analytics
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const AmplitudeCookieConsent = () => {
  const [consent, setConsent] = useState<boolean | null>(() =>
    AUTOMATIC_AMPLITUDE_ANALYTICS_CONSENT ? true : getAnalyticsConsent()
  );

  useEffect(() => {
    if (consent === true) {
      initializeAmplitude(AMPLITUDE_API_KEY);
      return;
    }

    removeAmplitudeCookies(AMPLITUDE_API_KEY);
  }, [consent]);

  const handleConsent = (value: boolean) => {
    setAnalyticsConsent(value);
    setConsent(value);
  };

  return (
    <AnalyticsConsentDialog
      open={consent === null}
      onAccept={() => handleConsent(true)}
      onReject={() => handleConsent(false)}
    />
  );
};
